import React, { useState } from "react";

// Model
import { faqs } from "../../model/data";

// Parallax
import { Parallax } from "react-parallax";

// Image
import SeeYou from "../../image/see_you.JPG";

// Hooks
import useDevice from "../../hooks/useDevice";

// Components
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
  Typography,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";

const FAQs = (props) => {
  const [expanded, setExpanded] = useState(false);
  const { device } = useDevice();

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div {...props} className={`vjc_main-faqs ${device}`}>
      <Divider sx={{ marginBottom: "50px" }}>
        <Typography variant="h1" sx={{ fontSize: "26px" }}>
          Frequently Asked Questions
        </Typography>
      </Divider>

      {[...faqs].map(
        ({ title, description, description2, noTransform }, index) => (
          <Accordion
            expanded={expanded === `panel${index + 1}`}
            onChange={handleChange(`panel${index + 1}`)}
            elevation={0}
            sx={{
              border: "none",
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography
                variant="body2"
                color="text.secondary"
                style={{ fontWeight: 600 }}
              >
                {title}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2" color="text.secondary">
                {description}
              </Typography>
              {description2 ? (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  style={{
                    marginTop: "10px",
                    fontWeight: noTransform ? 600 : "normal",
                    textTransform: noTransform ? "none" : "uppercase",
                  }}
                >
                  {description2}
                </Typography>
              ) : null}
            </AccordionDetails>
          </Accordion>
        )
      )}

      <Parallax bgImage={SeeYou} strength={300}>

        <Typography variant="h2" style={{ textShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)", }}>See you!</Typography>
      </Parallax>

      <div className="footer">
        <Typography
          variant="body2"
          color="text.secondary"
          style={{ fontWeight: 600, textTransform: "none" }}
        >
          © 2026 by Vincent James Bañaga
        </Typography>
        <IconButton
          onClick={() => {
            window.document.body.scrollTop = 0;
            window.document.documentElement.scrollTop = 0;
          }}
        >
          <ArrowCircleUpIcon />
        </IconButton>
      </div>
    </div>
  );
};

export default FAQs;
